import { FC } from 'react';
import { PageHeader } from 'components/page-header';
import { CountyCoverageContent } from './county-coverage-content';

const CountyCoveragePage: FC = () => {
  return (
    <>
      <PageHeader breadcrumbs={[]} title="County Coverage" actions={null} />
      <CountyCoverageContent />
    </>
  );
};

export { CountyCoveragePage };
